/** O board enquanto ele carrega (SPEC-FE-001 § 6).
 *
 * Esqueleto e não "Carregando o funil…": o texto centrado deixa a tela mudar
 * de forma inteira quando os dados chegam, e cada troca de layout custa uma
 * releitura à pessoa. O esqueleto ocupa desde já o espaço que as colunas vão
 * ocupar, então a chegada dos dados preenche em vez de reorganizar.
 *
 * **Ainda assim anuncia por escrito.** Forma cinzenta não diz nada a quem usa
 * leitor de tela, e "está carregando" é exatamente o que essa pessoa precisa
 * saber. O `role="status"` com texto em `sr-only` é o que impede o esqueleto de
 * ser uma melhoria só para quem enxerga.
 */

/** Quantas colunas fingir. Cinco é o funil padrão que o cadastro provisiona
 * (Prospecção → Qualificação → Proposta → Negociação → Fechamento), então na
 * conta nova o esqueleto acerta o número. */
const COLUNAS = 5;
const CARDS_POR_COLUNA = 3;

export function EsqueletoDoFunil() {
  return (
    <div role="status" aria-busy="true">
      <span className="sr-only">Carregando o funil…</span>
      <div aria-hidden="true" className="flex items-start gap-4 overflow-hidden pb-4">
        {Array.from({ length: COLUNAS }, (_, coluna) => (
          <div key={coluna} className="flex w-[300px] shrink-0 flex-col gap-3">
            <div className="flex flex-col gap-2 rounded-lg border border-borda bg-superficie p-3">
              <Barra className="h-3 w-24" />
              <Barra className="h-4 w-32" />
              <Barra className="h-1 w-full" />
            </div>
            {Array.from({ length: CARDS_POR_COLUNA }, (_, card) => (
              <div
                key={card}
                className="flex flex-col gap-2 rounded-lg border border-borda bg-superficie p-3"
              >
                <Barra className="h-4 w-4/5" />
                <Barra className="h-3 w-1/2" />
                <Barra className="h-3 w-2/3" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

/** Um retângulo pulsando.
 *
 * `motion-reduce:animate-none`: animação contínua é gatilho de desconforto
 * para parte das pessoas, e o sistema operacional delas já declara isso
 * (DESIGN.md § 8). Sem o pulso, o esqueleto continua fazendo o trabalho dele.
 */
function Barra({ className }: { className: string }) {
  return (
    <span
      className={`block animate-pulse rounded bg-canvas motion-reduce:animate-none ${className}`}
    />
  );
}
